import { cx } from "../lib/cx";

export interface SpinnerProps {
  size?: "sm" | "md" | "lg";
  className?: string;
  label?: string;
}

const SIZES: Record<NonNullable<SpinnerProps["size"]>, string> = {
  sm: "h-4 w-4",
  md: "h-6 w-6",
  lg: "h-9 w-9",
};

export function Spinner({ size = "md", className, label = "Memuat…" }: SpinnerProps) {
  return (
    <span role="status" aria-live="polite" className={cx("inline-flex items-center gap-2", className)}>
      <svg
        className={cx("animate-spin text-accent", SIZES[size])}
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeOpacity="0.2" strokeWidth="3" />
        <path
          d="M21 12a9 9 0 0 0-9-9"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
        />
      </svg>
      <span className="sr-only">{label}</span>
    </span>
  );
}

export interface LoadingBlockProps {
  message?: string;
  className?: string;
}

/** Centred loading placeholder used by every page/card. */
export function LoadingBlock({ message = "Memuat data…", className }: LoadingBlockProps) {
  return (
    <div className={cx("flex flex-col items-center justify-center gap-3 py-12 text-muted", className)}>
      <Spinner size="lg" label={message} />
      <p className="text-sm">{message}</p>
    </div>
  );
}
